import { z } from 'zod';
import { createStandardResponse } from '@/src/shared/data/schemas/responses/base';

export const SUpdateLastSeen = z.object({
  last_seen: z.coerce.date(),
});
export type TUpdateLastSeen = z.infer<typeof SUpdateLastSeen>;

export const SUpdateLastSeenResponse = createStandardResponse(SUpdateLastSeen);
export type TUpdateLastSeenResponse = z.infer<typeof SUpdateLastSeenResponse>;
